import { evalCondition, storeGet } from 'mailup-react-helpers'
import { STORE_KEY_ID_LIST } from 'mailup-react-helpers'

import { beMessApiGetEntitiesThatUseMessage } from 'Api/BeMessApi'
import { beSendGoCheckSendingProgress } from 'Api/beSendGoApi'
import { beEmailCheckupFastMessageCheck } from 'Api/beEmailCheckupApi'
import { ENTITY_TYPE_AUTOMATION_WORKFLOW } from 'Constants'
import { ENTITY_TYPE_TRIGGER } from 'Constants/'
import {
  CUSTOM_DOMAIN_CUSTOMIZABLE,
  CUSTOM_DOMAIN_NOT_CUSTOMIZABLE
} from 'Constants/index'
import { beAsyncTrackingApiCheckTrackingDomainIsCustomizable } from 'Api/beAsyncTracking'
import {
  beAccountSettingsAddSilencedAlerts,
  beAccountSettingsGetSilencedAlerts,
  beAccountSettingsGetUserSetting,
  beAccountSettingsUpsertUserSettings
} from 'Api/beAccountSettingsApi'

export async function updateWhitelist(idMessage, DataValue) {
  const idList = parseInt(storeGet(STORE_KEY_ID_LIST))
  const result = await beAccountSettingsUpsertUserSettings(
    idList,
    `whiteListDynamicField-NL-${encodeURIComponent(idMessage)}`,
    DataValue
  )
  return result || {}
}

export async function addSilencedAlerts(DataValue) {
  const idList = 0 // parseInt(storeGet(STORE_KEY_ID_LIST))
  const result = await beAccountSettingsAddSilencedAlerts(idList, DataValue)
  return result || {}
}

export async function getSilencedAlerts() {
  const idList = 0 // parseInt(storeGet(STORE_KEY_ID_LIST))
  const result = await beAccountSettingsGetSilencedAlerts(idList)
  return result || {}
}

export async function fastCheck(idMessage) {
  const checks = {
    Checks: [
      'Size',
      'MaxSize',
      'Attachments',
      'DynamicContents',
      'LinksWoTracking',
      'UnsubscribeLink',
      'Fields',
      'Preheader',
      'WebAnalytics',
      'LiquidCode',
      'Links',
      'Content'
    ]
  }

  const {
    CheckLiquidCode,
    CheckAttachments,
    CheckDynamicContents,
    CheckSize,
    CheckBlacklistResult,
    CheckLinksWoTracking,
    CheckUnsubscribeLink,
    CheckFields,
    CheckMaxSize,
    CheckPreheader,
    CheckWebAnalytics,
    CheckContent
  } = await beEmailCheckupFastMessageCheck(idMessage, checks)

  let domainCustomizableStatus = CUSTOM_DOMAIN_NOT_CUSTOMIZABLE
  try {
    const resultDomainIsCustomizable = await beAsyncTrackingApiCheckTrackingDomainIsCustomizable()
    const domainIsCustomizableOermission = evalCondition(
      'uo:GEST AND uo:SETTINGS'
    )
    if (resultDomainIsCustomizable && domainIsCustomizableOermission) {
      domainCustomizableStatus = resultDomainIsCustomizable.IsCustomizable
    }
  } catch (error) {
    domainCustomizableStatus = CUSTOM_DOMAIN_NOT_CUSTOMIZABLE
  }

  const entities = await beMessApiGetEntitiesThatUseMessage(idMessage)

  const workflows = entities.filter(
    ({ Type }) =>
      Type === ENTITY_TYPE_TRIGGER || Type === ENTITY_TYPE_AUTOMATION_WORKFLOW
  )

  const wrongDynamicTags = CheckFields.WrongDynamicTags.map(({ Value }) =>
    Value.replace(/[[\]]/g, '')
  ).filter(f => f !== '')

  const blocking =
    Number(!CheckLiquidCode) +
    Number(!CheckAttachments.Check) +
    Number(!CheckDynamicContents.Check) +
    Number(!CheckSize.Check) +
    Number(CheckBlacklistResult.Action === 2) +
    Number(CheckContent.Action === 2)

  const potential =
    Number(!CheckLinksWoTracking) +
    Number(!CheckUnsubscribeLink) +
    Number(!CheckMaxSize.Check) +
    Number(CheckBlacklistResult.Action === 1) +
    Number(wrongDynamicTags.length > 0) +
    Number(workflows.length > 0)

  const improvements =
    Number(!CheckPreheader) +
    Number(!CheckWebAnalytics) +
    Number(domainCustomizableStatus === CUSTOM_DOMAIN_CUSTOMIZABLE)

  return {
    blocking,
    potential,
    improvements
  }
}

export async function isSendingMessage(idMessage) {
  const { Value } = await beSendGoCheckSendingProgress(idMessage)
  return Value
}
export async function getEntitiesThatUseMessage(idMessage) {
  const entities = await beMessApiGetEntitiesThatUseMessage(idMessage)

  const workflows = entities.filter(
    ({ Type }) =>
      Type === ENTITY_TYPE_TRIGGER || Type === ENTITY_TYPE_AUTOMATION_WORKFLOW
  )
  return workflows.length > 0
}

export async function modalCheck(idMessage) {
  const checks = {
    Checks: [
      'Size',
      'MaxSize',
      'Attachments',
      'DynamicContents',
      'LinksWoTracking',
      'UnsubscribeLink',
      'Fields',
      'Preheader',
      'WebAnalytics',
      'LiquidCode',
      'Links',
      'Content'
    ]
  }

  const checkObj = await beEmailCheckupFastMessageCheck(idMessage, checks)

  let domainCustomizableStatus = CUSTOM_DOMAIN_NOT_CUSTOMIZABLE
  try {
    const resultDomainIsCustomizable = await beAsyncTrackingApiCheckTrackingDomainIsCustomizable()
    const domainIsCustomizableOermission = evalCondition(
      'uo:GEST AND uo:SETTINGS'
    )
    if (resultDomainIsCustomizable && domainIsCustomizableOermission) {
      domainCustomizableStatus = resultDomainIsCustomizable.IsCustomizable
    }
  } catch (error) {
    domainCustomizableStatus = CUSTOM_DOMAIN_NOT_CUSTOMIZABLE
  }

  checkObj.CustomDomainCustomizable =
    domainCustomizableStatus === CUSTOM_DOMAIN_CUSTOMIZABLE

  return checkObj
}

export async function getWhitelist(idMessage) {
  const idList = parseInt(storeGet(STORE_KEY_ID_LIST))
  const result = await beAccountSettingsGetUserSetting(
    idList,
    `whiteListDynamicField-NL-${encodeURIComponent(idMessage)}`
  )
  return result || {}
}
